import React, { useState, useEffect, Fragment, useMemo, useCallback } from "react";
import LayoutHOC from "../LayoutHOC";
import {
  useLazyFetchPersonInTableQuery,
  useFetchCustomerTableDataNewMutation,
} from "../../utils/customer/customerTable";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getUserTokeData } from "../../utils/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import AddItemPlus from "../UniversalComponents/AddItemPlus";
import { ErrorBoundary } from "react-error-boundary";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import {
  getCompanyId,
  getMySpaceColumnOrder,
  getMySpaceVisibleFields,
  getUserToken,
  setMySpaceColumnOrder,
  setMySpaceVisibleFields,
} from "../../utils/utilityFunctions/localServices";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
// import { ReactComponent as ThreeDotMenu } from "../../assets/images/threeDotVertical.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/deleteIconCoaTable.svg";
import { ReactComponent as PlusGrayIcon } from "../../assets/images/icons/Blackplusicon.svg";
import { ReactComponent as CreateSomethingNew } from "../../assets/images/create_something_new.svg";
import ManageIcon from "../../assets/images/icons/ManageIcon";
import { ReactComponent as SearchItemNotFound } from "../../assets/images/searchItemNotFound.svg";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import {
  mySpaceAddColumnOptions,
  mySpaceAddField,
  mySpaceAddUpdateCell,
  mySpaceData,
  mySpaceDeleteColumns,
  mySpaceDeleteOption,
  mySpaceFieldOptions,
  mySpaceGetHeaders,
  mySpacePersonList,
  mySpaceTableBulkUpdateListValue,
  mySpaceTableColumnUpdate,
  mySpaceTableRowAddUpdate,
  mySpaceTableRowDelete,
} from "../../utils/api/mySpaceApi";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ReplyIcon from "@mui/icons-material/Reply";

import CustomerReactTable from "../UniversalComponents/CustomerReactTable";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import ShareFileModal from "./ShareFileModal";
import AddFieldDrawer from "../GlobalFeature/Table/AddFieldDrawer";
import { useSidebar } from "../SidebarContext";
import MySpaceDocument from "./MySpaceDocument";
import {
  formatNegativeNumber,
  formatTextValue,
  IndeterminateCheckbox,
  safeJsonParse,
} from "../../utils/utilityFunctions/stringUtility";
import HighlightedParagraph from "../UniversalComponents/HighlightedParagraph";
import TableHeaderColumnAddUpdateDrawer from "./TableHeaderColumnAddUpdateDrawer";
import { color } from "framer-motion";
import CsvUploadPreview from "./CsvUploadPreview";
import ResponsiveTags from "../../utils/utilityFunctions/ResponsiveTags";
import Button from "../UniversalComponents/DefaultButton";
import MenuOptionsDropdown from "./MenuOptionsToCreate";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import TableListRowAddEditComponent from "../UniversalComponents/TableListRowAddEditComponent";
import GetPersonAvatar from "../UniversalComponents/GetPersonAvatar";
import ManageViewDrawer from "./ManageViewDrawer";
import ErrorFallback from "./ErrorFallback";
import { hexToRgba } from "../../utils/utilityFunctions/color";
import Breadcrumb from "../UniversalComponents/Breadcrumb";
import {
  buildOptionsFromListMySpace,
  generateUniqueValuesMySpace,
} from "../../utils/utilityFunctions/CustomerReactTable/CustomerUtility";

const MySpace = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const companyId = getCompanyId();
  const navigate = useNavigate();

  //----------------------------------------------- URL TYPE AND CONTAINER ID CHECK -----------------------------------------------
  const { "*": wildcard } = useParams(); // everything after /my_space/

  const { type, urlContainerId, isShared } = useMemo(() => {
    if (!wildcard) return { type: null, urlContainerId: null, isShared: false };

    const parts = wildcard.split("/").filter(Boolean);
    const validTypes = ["folders", "tables"];

    let isShared = false;
    let type = null;
    let urlContainerId = null;

    // Case: /shared/folders or /shared/folders/:id
    if (parts[0] === "shared" && validTypes.includes(parts[1])) {
      isShared = true;
      type = parts[1];
      urlContainerId = parts[2] || null; // may be undefined
    }
    // Case: /folders or /folders/:id
    else if (validTypes.includes(parts[0])) {
      type = parts[0];
      urlContainerId = parts[1] || null;
    }

    return { type, urlContainerId, isShared };
  }, [wildcard]);

  //----------------------------------------------- URL TYPE AND CONTAINER ID CHECK -----------------------------------------------

  // TO MAKE TABLE-ID PERSISTENT IN URL FROM REFRESH
  // const queryParams = new URLSearchParams(location?.search);
  // const queryContainerId = queryParams.get("containerId")?.replace(/^"|"$/g, "");
  const [containerId, setContainerId] = useState(urlContainerId);
  const [showListView, setShowListView] = useState(type === "tables" ? true : false);

  // useEffect(() => {
  //   if (queryContainerId) {
  //     setContainerId(queryContainerId);
  //   }
  // }, [queryContainerId]);

  const [multiData, setMultiData] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showShareFileModal, setShowShareFileModal] = useState(false);
  const [headerConfigData, setHeaderConfigData] = useState([]);
  const [mySpaceBody, setMySpaceBodyData] = useState([]);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [iserror, setIsError] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();

  const [showCsvUploadPreview, setShowCsvUploadPreview] = useState(false);
  const [csvFileData, setCsvFileData] = useState(null);

  const [lastSelectedRowIndex, setLastSelectedRowIndex] = useState(null);
  const [grouping, setGrouping] = useState([]);

  const [mySpaceDocumentList, setMySpaceDocumentList] = useState([]);
  const [selectedtableRowId, setSelectedtableRowId] = useState(null);
  const [rowAddEditMode, setRowAddEditMode] = useState("add");

  const [isActive, setIsActive] = useState(false);

  const [showConfirmDialog, setShowConfirmDialog] = useState({ show: false, data: {} });
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [showManageViewDrawer, setShowManageViewDrawer] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({ hidden_fields: [], visible_fields: [] });
  const [tableColumnsVisibility, setTableColumnsVisibility] = useState({});
  const [menuVisible, setMenuVisible] = useState(false);
  const [isMangeHovered, setIsMangeHovered] = useState(false);

  const [isDetailsVisible, setDetailsVisible] = useState(false);

  const [columnOrder, setColumnOrder] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [resetPageIndex, setResetPageIndex] = useState(true);
  const [extraField, setExtraField] = useState(false);
  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();
  const [fieldOptionsData, setFieldOptionsData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [isEditableFieldModeActive, setIsEditableFieldModeActive] = useState(null);
  const [breadcrumpList, setBreadcrumpList] = useState([{ label: "My Space", isContainer: true }]);
  const [isAdvancedFilterOpen, setIsAdvancedFilterOpen] = useState(false);

  // const [searchParams] = useSearchParams();
  // const tableId = searchParams.get('tableId');

  const reorderVisibleFields = (listViewData, draggedIndex, targetIndex) => {
    if (
      draggedIndex < 0 ||
      targetIndex < 0 ||
      draggedIndex >= listViewData.visible_fields.length ||
      targetIndex >= listViewData.visible_fields.length
    ) {
      return listViewData; // Return unchanged if indices are invalid
    }

    // Create a copy to prevent mutation
    const updatedVisibleFields = [...listViewData.visible_fields];

    // Remove the dragged item and insert it at the target position
    const [movedItem] = updatedVisibleFields.splice(draggedIndex, 1);
    updatedVisibleFields.splice(targetIndex, 0, movedItem);

    // Return the updated listViewData with new order
    return { ...listViewData, visible_fields: updatedVisibleFields };
  };

  const handleReorderFields = (sourceIndex, targetIndex) => {
    const updatedData = reorderVisibleFields(columnVisibility, sourceIndex, targetIndex);
    setColumnVisibility(updatedData);

    // Store order state locally
    setMySpaceColumnOrder(containerId, ["select", ...updatedData.visible_fields]);

    setColumnOrder(["select", ...updatedData.visible_fields]);
  };

  const fetchFieldOptions = useCallback(
    async (data) => {
      const columnHeaderData = headerConfigData?.find((header) => header?.value === data);
      if (columnHeaderData?.type === "dropdown" || columnHeaderData?.type === "multiselect") {
        const response = await mySpaceFieldOptions({ params: { fieldId: columnHeaderData?.id } });

        if (response?.success) {
          if (response?.data?.length > 0) {
            const formatedResponse = response?.data?.map((data) => {
              return {
                value: data?.value,
                color_code: data?.color_code,
                uuid: data?.id,
                id: data?.id,
                field_id: columnHeaderData?.id,
              };
            });

            setFieldOptionsData({ success: true, data: formatedResponse });
          } else {
            setFieldOptionsData({ success: true, data: [] });
          }
        } else {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.data?.message,
              type: "danger",
            })
          );
        }
      }
    },
    [headerConfigData]
  );

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: getUserToken(), data: data, companyId: companyId?.company_id });
  };

  //For setting data in Header
  // const sidebarContext = useSidebar();
  // const setheaderProps = sidebarContext?.setheaderProps;

  // function MySpaceHeaderUI() {
  //   return <button>Zinancial</button>;
  // }

  // useEffect(() => {
  //   setheaderProps({ name: "VADS Consulting Pvt. Ltd." });
  //   document.title = "Zinancial | My Space";
  //   return () => {
  //     setheaderProps(null);
  //     document.title = "Zinancial";
  //   };
  // }, [setheaderProps]);

  const jsonStringFilter = (row, columnId, filterValue) => {
    const cellValue = row.getValue(columnId); // Convert to string
    return filterValue.every((filterStr) =>
      cellValue?.some((person) => person.email?.toLowerCase().includes(filterStr?.toLowerCase()))
    );
  };

  const multiSelectFilterFn = (row, columnId, filterValue) => {
    // If no filter is applied, return true (i.e. show the row)
    if (!filterValue || filterValue?.length === 0) return true;
    // Check if the row value is included in the selected values
    return filterValue.includes(row.getValue(columnId)?.value);
  };
  // multiSelectFilterFnForPage.js
  function filterColumn(row, columnId, filterValue) {
    // no filter applied
    if (!filterValue || (Array.isArray(filterValue) && filterValue.length === 0)) return true;

    const safeParse = (s) => {
      try {
        return typeof s === "string" ? JSON.parse(s) : null;
      } catch {
        return null;
      }
    };
    const normalize = (v) => (v === null || v === undefined ? "" : String(v).trim().toLowerCase());

    // Extract comparable strings from many shapes
    const extractStrings = (entry) => {
      if (entry == null) return [];
      if (typeof entry === "string" || typeof entry === "number" || typeof entry === "boolean") {
        // entry may be a JSON string
        if (typeof entry === "string") {
          const p = safeParse(entry);
          if (p && typeof p === "object") return extractStrings(p);
        }
        return [normalize(entry)];
      }

      if (Array.isArray(entry)) {
        const acc = [];
        for (const item of entry) {
          if (item == null) continue;
          // person-like
          if (item.email) acc.push(normalize(item.email));
          else if (item.value !== undefined && (typeof item.value === "string" || typeof item.value === "number"))
            acc.push(normalize(item.value));
          else if (typeof item.value === "object" && item.value !== null) {
            // inner wrapper
            if (item.value.value !== undefined) acc.push(normalize(item.value.value));
            else if (item.value.textForUrl) acc.push(normalize(item.value.textForUrl));
            else if (item.value.url) acc.push(normalize(item.value.url));
          } else {
            // fallback primitives inside array
            for (const k of ["textForUrl", "url", "name", "email", "value"]) {
              if (item[k] !== undefined) {
                acc.push(normalize(item[k]));
                break;
              }
            }
          }
        }
        return acc.filter(Boolean);
      }

      if (typeof entry === "object") {
        // person-wrapper: entry.value is array -> handled above by recursion
        if (Array.isArray(entry.value)) return extractStrings(entry.value);

        // wrapper with primitive value
        if (
          entry.value !== undefined &&
          (typeof entry.value === "string" || typeof entry.value === "number" || typeof entry.value === "boolean")
        ) {
          return [normalize(entry.value)];
        }

        // wrapper with object value { url, textForUrl }
        if (entry.value && typeof entry.value === "object") {
          const v = entry.value;
          if (v.textForUrl) return [normalize(v.textForUrl)];
          if (v.url) return [normalize(v.url)];
          if (v.value !== undefined) return [normalize(v.value)];
        }

        // direct choice object { id, value, color_code }
        if (entry.value !== undefined && (typeof entry.value === "string" || typeof entry.value === "number")) {
          return [normalize(entry.value)];
        }

        // direct person object
        if (entry.email) return [normalize(entry.email)];

        // fallback: try common fields
        for (const k of ["textForUrl", "url", "email", "name", "value"]) {
          if (entry[k] !== undefined) return [normalize(entry[k])];
        }

        // final fallback: stringify small primitive field
        for (const k of Object.keys(entry)) {
          const v = entry[k];
          if (typeof v === "string" || typeof v === "number" || typeof v === "boolean") return [normalize(v)];
        }

        return [];
      }

      return [];
    };

    // Build set of selected normalized strings
    const selectedSet = new Set();
    const fvArr = Array.isArray(filterValue) ? filterValue : [filterValue];
    for (const fv of fvArr) {
      if (fv == null) continue;
      if (typeof fv === "object") {
        // fv might be wrapper { value: ... } or inner object - extract strings from it
        selectedSetAddFrom(fv);
      } else if (typeof fv === "string") {
        const parsed = safeParse(fv);
        if (parsed && typeof parsed === "object") selectedSetAddFrom(parsed);
        else selectedSet.add(normalize(fv));
      } else {
        selectedSet.add(normalize(fv));
      }
    }

    function selectedSetAddFrom(x) {
      const arr = extractStrings(x);
      arr.forEach((s) => s && selectedSet.add(s));
    }

    // Extract from row cell and check membership
    const cell = row.getValue(columnId);
    const cellStrings = extractStrings(cell);
    for (const s of cellStrings) {
      if (selectedSet.has(s)) return true;
    }
    return false;
  }

  //commented out existing function

  // const filterColumn = (row, columnId, filterValue, headerType) => {
  //   const columnData = row.getValue(columnId);

  //   let isFound = false;

  //   if (filterValue?.length === 0) {
  //     isFound = true;
  //   } else {
  //     // For multi Select
  //     if (headerType == "multiselect") {
  //       const refineFilterValues = filterValue?.map((data) => data?.value);
  //       columnData?.value?.forEach((data) => {
  //         if (refineFilterValues.includes(data?.value)) {
  //           isFound = true;
  //         }
  //       });
  //     }
  //     // For single Select
  //     else if (headerType == "dropdown") {
  //       const refineFilterValues = filterValue?.map((data) => safeJsonParse(data)?.value);
  //       if (refineFilterValues.includes(columnData?.value?.value)) {
  //         isFound = true;
  //       }
  //     }
  //     // For Simple text/number inputs
  //     else if (headerType == "text" || headerType == "number") {
  //       if (filterValue.includes(row?.original[columnId]?.value)) {
  //         isFound = true;
  //       }
  //     } else {
  //       isFound = true;
  //     }
  //   }

  //   return isFound;
  // };

  const handleRowSelection = (event, rowId, index, tableData) => {
    //const checkindex=tableData.getRowModel().rows.findIndex((item)=>item.original.id==rowId)

    setMultiData((prev) => {
      let newSelectedRows = { ...prev };
      let currentIndex;
      tableData.getRowModel().rows.map((item, index) => {
        if (item.original.id === rowId) {
          currentIndex = index;
        }
      });

      setLastSelectedRowIndex((prevLastIndex) => {
        if (event.shiftKey && prevLastIndex !== null) {
          const lowerIndex = Math.min(prevLastIndex, currentIndex);
          const upperIndex = Math.max(prevLastIndex, currentIndex);

          for (let i = lowerIndex; i <= upperIndex; i++) {
            newSelectedRows[tableData.getRowModel().rows[i]?.original?.id] = true;
          }
        } else {
          if (newSelectedRows[rowId]) {
            delete newSelectedRows[rowId];
          } else {
            newSelectedRows[rowId] = true;
          }
        }

        return currentIndex;
      });

      return newSelectedRows;
    });
  };

  const closeAdvancedFilter = () => {
    setIsAdvancedFilterOpen(false);
  };

  const handleEditRow = async (rowInfo = {}) => {
    const rowData = [];
    let columnMetaType;
    let columnLabel;
    for (let columnName of Object.keys(rowInfo)) {
      columnLabel = headerConfigData.find((item) => item?.value === columnName)?.label || columnName;
      columnMetaType = null;
      // TODO - CUSTOMER TABLE IS HAVING UNNECESSARY ID COLUMN...
      if (columnName === "id") {
        continue;
      }

      // Finding column type
      let columnInfo = headerConfigData.find((item) => item?.value === columnName) || null;
      let columnDropdownOptions = [];

      // Initial value defined for text and value and updatingit later for dropdown/multiselect
      let columnValue = rowInfo[columnName]?.value;

      // Get options for dropdown like inputs
      if (columnInfo?.type === "dropdown" || columnInfo?.type === "multiselect") {
        // Using self invocation to get options in async

        const response = await mySpaceFieldOptions({ params: { fieldId: columnInfo?.id } });
        if (!response?.success) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }
        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.value,
            color_code: data?.color_code,
          };
        });

        if (columnInfo?.type === "dropdown") {
          columnValue = [
            {
              value: rowInfo[columnName]?.value?.id,
              label: rowInfo[columnName]?.value?.value,
              color_code: rowInfo[columnName]?.value?.color_code,
            },
          ];
        } else {
          columnValue = rowInfo[columnName]?.value?.map((cellOption) => {
            return {
              value: cellOption?.id,
              label: cellOption?.value,
              color_code: cellOption?.color_code,
            };
          });
        }
      } else if (columnInfo?.type === "person" || columnInfo?.type === "multi_person") {
        const response = await mySpacePersonList({ params: { companyId: getCompanyId() } });

        if (!response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }

        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.uuid,
            label: data?.name,
            subLabel: data?.email,
            id: data?.id,
          };
        });

        columnValue = rowInfo[columnName]?.value?.map((cellOption) => {
          return {
            id: cellOption?.id,
            value: cellOption?.uuid,
            label: cellOption?.name,
            subLabel: cellOption?.email,
          };
        });
      } else if (columnInfo?.type === "text") {
        // if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
        columnMetaType = columnInfo?.meta?.textFormat?.textSelectedOption;
        // }
      }

      rowData.push({
        name: columnLabel || null,
        value: columnValue || null,
        type: columnInfo?.type || null,
        options: columnDropdownOptions || null,
        id: columnInfo?.id || null,
        columnMetaType: columnMetaType || null,
        row_id: rowInfo.id,
      });
    }

    setShowAddEditModal({ show: true, data: rowData });
    setRowAddEditMode("edit");
  };

  const handleAddRow = async () => {
    // Finding column type
    let rowData = [];
    for (let columnInfo of headerConfigData) {
      const columnName = columnInfo?.label;
      let columnDropdownOptions = [];
      let columnMetaType = null;

      // Initial value defined for text and value and updatingit later for dropdown/multiselect
      let columnValue = null;

      // Get options for dropdown like inputs
      if (columnInfo?.type === "dropdown" || columnInfo?.type === "multiselect") {
        // Using self invocation to get options in async

        const response = await mySpaceFieldOptions({ params: { fieldId: columnInfo?.id } });
        if (!response?.success) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }
        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.value,

            color_code: data?.color_code,
          };
        });
      } else if (columnInfo?.type === "text") {
        // if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
        columnMetaType = columnInfo?.meta?.textFormat?.textSelectedOption;
        // }
      } else if (columnInfo?.type === "person" || columnInfo?.type === "multi_person") {
        const response = await mySpacePersonList({ params: { companyId: getCompanyId() } });

        if (!response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }

        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.uuid,
            label: data?.name,
            subLabel: data?.email,
            id: data?.id,
          };
        });
      } else if (columnInfo?.type === "text") {
        if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
          columnMetaType = "Hyperlink";
        }
      } else if (columnInfo?.type === "date") {
        if (columnInfo?.meta?.dateTimeFormat?.timeDisplay === "Date & Time") {
          columnMetaType = "dateTime";
        } else {
          columnMetaType = "date";
        }
      }

      rowData.push({
        name: columnName || null,
        value: columnValue || null,
        type: columnInfo?.type || null,
        options: columnDropdownOptions || null,
        id: columnInfo?.id || null,
        columnMetaType: columnMetaType || null,
        row_id: null,
      });
    }
    setShowAddEditModal({ show: true, data: rowData });
  };

  const handleRowAddEditSubmit = async (formData) => {
    try {
      let finalRequestPayload = [];

      formData.forEach((inputData) => {
        if (inputData?.type === "text" || inputData?.type === "number" || inputData?.type === "date") {
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: inputData?.value } },
          ];
        } else if (inputData?.type === "multiselect") {
          const modifiedValue = inputData?.value?.map((data) => {
            return data?.value;
          });
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: modifiedValue || [] } },
          ];
        } else if (inputData?.type === "dropdown") {
          const singleSelectedValue =
            inputData?.value && inputData?.value?.length > 0 ? [inputData?.value[0]?.value] : [];
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: singleSelectedValue || [] } },
          ];
        } else if (inputData?.type === "person" || inputData?.type === "multi_person") {
          const modifiedValue = inputData?.value?.map((data) => {
            return {
              id: data?.id,
              name: data?.label,
              email: data?.subLabel,
              uuid: data?.value,
            };
          });
          finalRequestPayload = [
            ...finalRequestPayload,
            { field_id: inputData?.id, value: { value: modifiedValue || [] } },
          ];
        }
      });

      const payload = {
        cells: finalRequestPayload,
      };
      if (selectedtableRowId) {
        payload.row_id = selectedtableRowId;
      }
      const response = await mySpaceTableRowAddUpdate({ params: { tableId: containerId }, body: payload });
      if (response?.success) {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "success" }));
        await fetchMySpaceHeaderConfig(containerId);
        setShowAddEditModal({});
        setSelectedtableRowId(null);
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message, type: "danger" }));
    }
  };

  const columns = useMemo(() => {
    const dynamicColumns =
      headerConfigData?.map((header, headerIndex) => ({
        accessorKey: header.value === "tasks" ? "task_date" : header.value,
        header: header.label, // Use label key for header
        meta: { position: "left", filterVariant: "select", type: header?.type, ...header?.meta },
        enableFiltering: false,
        // filterVariant: "select",

        filterFn: (row, columnId, filterValue) => filterColumn(row, columnId, filterValue, header.type),
        // ...(header.value === "delegation" ? { filterFn: jsonStringFilter } : { filterFn: multiSelectFilterFn }),
        // ...([].includes(header.value) && { enableColumnFilter: false }),
        enableColumnFilter: true,
        sortUndefined: "1", // Disable filtering by default
        cell: (info) => {
          const value = info.getValue();
          try {
            const parsedValue = safeJsonParse(value);

            if (header?.type === "multi_person" || header?.type === "person") {
              return (
                <p className="w-fit max-w-[10vw]">
                  <GetPersonAvatar
                    personList={parsedValue?.value}
                    header={header}
                    rowKey={info.row.original?.id}
                    isDetailsVisible={isDetailsVisible}
                    setDetailsVisible={setDetailsVisible}
                  />
                </p>
              );
            } else if (header?.type === "text") {
              const { textSelectedOption } = header?.meta?.textFormat || {};
              return (
                <>
                  <span className="flex gap-4 justify-between truncate ">
                    <HighlightedParagraph
                      className={`w-full`}
                      paragraph={
                        textSelectedOption === "Hyperlink"
                          ? formatTextValue(parsedValue, textSelectedOption, true)
                          : formatTextValue(parsedValue?.value, textSelectedOption, false)
                      }
                      searchTerm={globalFilter}
                    />

                    {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                    {headerIndex == 0 && info.row.original.id && (
                      <span className="invisible group-hover:visible">
                        <MenuOptionsDropdown
                          buttonIcon={<MoreVertIcon />}
                          menuItems={[
                            {
                              label: "Edit",
                              icon: "",
                              onClick: () => {
                                handleEditRow(info?.row?.original);
                                setSelectedtableRowId(info?.row?.original?.id);
                              },
                            },
                            {
                              label: "Delete",
                              icon: "",
                              onClick: () => {
                                deleteSingleRowInTable([info.row.original.id]);
                              },
                            },
                          ]}
                          onOpen={() => console.log("Dropdown Opened")}
                          onClose={() => console.log("Dropdown Closed")}
                        />
                      </span>
                    )}
                  </span>
                </>
              );
            } else if (header?.type === "date") {
              return (
                <>
                  <HighlightedParagraph paragraph={parsedValue?.value} searchTerm={globalFilter} />
                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                  {headerIndex == 0 && info.row.original.id && (
                    <span className="invisible group-hover:visible">
                      <MenuOptionsDropdown
                        buttonIcon={<MoreVertIcon />}
                        menuItems={[
                          {
                            label: "Edit",
                            icon: "",
                            onClick: () => {
                              handleEditRow(info?.row?.original);
                              setSelectedtableRowId(info?.row?.original?.id);
                            },
                          },
                          {
                            label: "Delete",
                            icon: "",
                            onClick: () => {
                              deleteSingleRowInTable([info.row.original.id]);
                            },
                          },
                        ]}
                        onOpen={() => console.log("Dropdown Opened")}
                        onClose={() => console.log("Dropdown Closed")}
                      />
                    </span>
                  )}
                </>
              );
            } else if (header?.type === "number") {
              return (
                <>
                  <HighlightedParagraph
                    paragraph={
                      header?.meta
                        ? formatNegativeNumber(
                            parsedValue?.value,
                            header?.meta?.numberFormat?.negativeFormat,
                            header?.meta?.numberFormat?.selectedOption,
                            header?.meta?.numberFormat?.decimalPlaces,
                            header?.meta?.numberFormat?.separators,
                            header?.meta?.numberFormat?.symbol
                          )
                        : parsedValue?.value?.value || parsedValue?.value
                    }
                    searchTerm={globalFilter}
                  />

                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                  {headerIndex == 0 && info.row.original.id && (
                    <span className="invisible group-hover:visible">
                      <MenuOptionsDropdown
                        buttonIcon={<MoreVertIcon />}
                        menuItems={[
                          {
                            label: "Edit",
                            icon: "",
                            onClick: () => {
                              handleEditRow(info?.row?.original);
                              setSelectedtableRowId(info?.row?.original?.id);
                            },
                          },
                          {
                            label: "Delete",
                            icon: "",
                            onClick: () => {
                              deleteSingleRowInTable([info.row.original.id]);
                            },
                          },
                        ]}
                        onOpen={() => console.log("Dropdown Opened")}
                        onClose={() => console.log("Dropdown Closed")}
                      />
                    </span>
                  )}
                </>
              );
            } else if (Array.isArray(parsedValue?.value)) {
              return (
                <>
                  <ResponsiveTags parsedValue={parsedValue?.value} />
                  {headerIndex == 0 && info.row.original.id && (
                    <span className="invisible group-hover:visible">
                      <MenuOptionsDropdown
                        buttonIcon={<MoreVertIcon />}
                        menuItems={[
                          {
                            label: "Edit",
                            icon: "",
                            onClick: () => {
                              handleEditRow(info?.row?.original);
                              setSelectedtableRowId(info?.row?.original?.id);
                            },
                          },
                          {
                            label: "Delete",
                            icon: "",
                            onClick: () => {
                              deleteSingleRowInTable([info.row.original.id]);
                            },
                          },
                        ]}
                        onOpen={() => console.log("Dropdown Opened")}
                        onClose={() => console.log("Dropdown Closed")}
                      />
                    </span>
                  )}
                </>
              );
            } else if (typeof parsedValue?.value === "object") {
              const rgbaColor =
                parsedValue?.color_code || parsedValue?.value?.color_code || parsedValue?.code
                  ? `${parsedValue.color_code || parsedValue?.value?.color_code || parsedValue.code}99`
                  : undefined;
              return (
                <div
                  className={`${rgbaColor && "px-2 py-1"} group rounded min-w-full max-w-[10vw] text-ellipsis overflow-hidden flex justify-between items-center`}
                  style={{
                    backgroundColor: hexToRgba(rgbaColor, 0.1),
                    color: rgbaColor ? hexToRgba(rgbaColor) : "black",
                    borderRadius: "5px",
                    border: rgbaColor ? `0.8px solid ${rgbaColor}` : "none",
                  }}
                >
                  <HighlightedParagraph
                    paragraph={<>{parsedValue?.value?.value || parsedValue?.value}</>}
                    searchTerm={globalFilter}
                  />

                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY */}
                  {headerIndex == 0 && info.row.original.id && (
                    <span className="invisible group-hover:visible">
                      <MenuOptionsDropdown
                        buttonIcon={<MoreVertIcon />}
                        menuItems={[
                          {
                            label: "Edit",
                            icon: "",
                            onClick: () => {
                              handleEditRow(info?.row?.original);
                              setSelectedtableRowId(info?.row?.original?.id);
                            },
                          },
                          {
                            label: "Delete",
                            icon: "",
                            onClick: () => {
                              deleteSingleRowInTable([info.row.original.id]);
                            },
                          },
                        ]}
                        onOpen={() => console.log("Dropdown Opened")}
                        onClose={() => console.log("Dropdown Closed")}
                      />
                    </span>
                  )}
                </div>
              );
            } else {
              return (
                <div
                  className={`py-1 rounded min-w-full max-w-[10vw] text-ellipsis overflow-hidden flex justify-between`}
                >
                  {parsedValue?.value || <p></p>}

                  {/* // TO SHOW MENU ON FIRST COLUMN ONLY AND AVOID ADDING ON LAST COLUMN */}
                  {headerIndex == 0 && info.row.original.id && (
                    <span className="invisible group-hover:visible">
                      <MenuOptionsDropdown
                        buttonIcon={
                          <span>
                            <MoreVertIcon />
                          </span>
                        }
                        menuItems={[
                          {
                            label: "Edit",
                            icon: "",
                            onClick: () => {
                              handleEditRow(info?.row?.original);
                              setSelectedtableRowId(info?.row?.original?.id);
                            },
                          },
                          {
                            label: "Delete",
                            icon: "",
                            onClick: () => {
                              deleteSingleRowInTable([info.row.original.id]);
                            },
                          },
                        ]}
                        onOpen={() => console.log("Dropdown Opened")}
                        onClose={() => console.log("Dropdown Closed")}
                      />
                    </span>
                  )}
                </div>
              );
            }
          } catch (error) {}
          return (
            <HighlightedParagraph
              paragraph={<p className="w-fit max-w-[10vw] text-ellipsis overflow-hidden ">{JSON.stringify(value)}</p>}
              searchTerm={globalFilter}
            />
          );
        },
      })) || [];

    const staticColumn = [
      ...(grouping.length === 0
        ? [
            {
              id: "select",
              header: ({ table }) => {
                const allRows = table.getRowModel().rows;
                const allRowIds = allRows.map((row) => row.original.id);

                const allSelected = allRowIds?.every((id) => multiData[id]);
                const someSelected = allRowIds?.some((id) => multiData[id]);

                return (
                  <IndeterminateCheckbox
                    {...{
                      checked: allSelected,
                      indeterminate: someSelected && !allSelected,
                      onChange: (e) => {
                        if (e.target.checked) {
                          setLastSelectedRowIndex(null);
                          setMultiData((prev) => ({
                            ...prev,
                            ...Object.fromEntries(allRowIds.map((id) => [id, true])),
                          }));
                        } else {
                          setLastSelectedRowIndex(null);
                          setMultiData((prev) => {
                            const updated = { ...prev };
                            allRowIds.forEach((id) => delete updated[id]);
                            return updated;
                          });
                        }
                      },
                    }}
                  />
                );
              },
              cell: ({ row, table }) => {
                return (
                  <div className="">
                    {row?.original?.id && (
                      <IndeterminateCheckbox
                        {...{
                          checked: multiData[row.original.id],
                          disabled: !row.getCanSelect(),
                          indeterminate: row.getIsSomeSelected(),
                          onClick: (e) => handleRowSelection(e, row.original.id, row.index, table),
                        }}
                      />
                    )}
                  </div>
                );
              },
            },
          ]
        : []),
      // {
      //   id: "groupedColumn",
      //   header: ({ table }) =>
      //     grouping.length > 1
      //       ? "Group"
      //       : table
      //           .getAllColumns()
      //           .filter((col) => col.columnDef.accessorKey === grouping[0])
      //           .map((col) => col.columnDef.header)[0] || grouping[0],
      //   cell: () => null,
      // },
    ];

    // If columns are not created.
    if (headerConfigData?.length > 0) {
      return [...staticColumn, ...dynamicColumns];
    }
    return null;
  }, [headerConfigData, multiData, globalFilter]);

  const memoizedCustomerData = useMemo(() => {
    // if (globalFilter?.length > 0) {
    // }
    return mySpaceBody;
  }, [mySpaceBody, headerConfigData, globalFilter]);

  const [{ data: customerTableALL, isLoading: customerListLoading, isFetching: customerListFetching }] =
    useFetchCustomerTableDataNewMutation();

  const handleBulkFieldUpdateList = async ({ tableId, fieldId, rowsIds, value }) => {
    try {
      const response = await mySpaceTableBulkUpdateListValue({
        params: { tableId: tableId },
        body: {
          fieldId: fieldId,
          rowIds: rowsIds,
          data: { value },
        },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleTableFieldUpdate = async (item, field_name, cell) => {
    try {
      const columnInfo = headerConfigData?.find((header) => header?.value === cell?.column?.id);
      const row_id = Number(cell?.row?.original?.id) || "";
      let data = null;

      if (columnInfo?.type === "multiselect") {
        data = item?.map((optionObj) => optionObj?.id);
      } else if (columnInfo?.type === "dropdown") {
        data = [item?.uuid];
      } else {
        data = item;
      }

      const checkBoxSelectedIds = Object.keys(multiData).filter((info) => {
        return !isNaN(Number(info));
      });

      if (checkBoxSelectedIds?.length > 0) {
        await handleBulkFieldUpdateList({
          tableId: containerId,
          fieldId: columnInfo?.id,
          rowsIds: checkBoxSelectedIds,
          value: data,
        });
        return;
      }

      let body = {
        row_id: row_id,
        field_id: columnInfo?.id,
        value: { value: data },
      };

      const response = await mySpaceAddUpdateCell({ body, params: { tableId: containerId } });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );

        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  // CRAETE COLUMN IN MY SPACE
  const handleAddTableColumn = async (fielddata) => {
    try {
      const body = {
        field_label: fielddata?.field_label,
        field_type: fielddata?.field_type,
        field_description: fielddata?.field_description,
        meta: fielddata?.meta || null,
      };

      if (
        fielddata?.field_type?.toLowerCase() === "dropdown" ||
        fielddata?.field_type?.toLowerCase() === "multiselect"
      ) {
        body.options = fielddata?.field_options.map((data) => ({ value: data?.value, color_code: data?.color_code }));
      }

      const params = {
        tableId: containerId,
      };

      const response = await mySpaceAddField({ body, params });

      if (response?.success) {
        const createdNewColumnId = response?.data?.id;

        // if (fielddata?.field_type === "dropdown") {
        //   await handleAddColumnOptions(fielddata, createdNewColumnId);
        // }
        await fetchMySpaceHeaderConfig(containerId);
        setExtraField((prev) => !prev);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleUpdateTableColumn = async (fieldData) => {
    try {
      const params = {
        tableId: containerId,
        fieldId: fieldData?.fieldId,
      };
      let body = {
        fieldData: fieldData?.field_label,
      };

      if (fieldData?.field_type === "number") {
        const { negativeFormat, selectedOption, decimalPlaces, separators, symbol } =
          fieldData?.meta?.numberFormat || {};

        let newSeparators = separators;
        let newSymbol = symbol;

        switch (selectedOption) {
          case "Number":
            newSymbol = false;
            break;
          case "Percentage":
            newSeparators = false;
            newSymbol = false;
            break;
          // For "Currency", use default values (no change)
        }

        body = {
          ...fieldData,
          meta: {
            numberFormat: {
              negativeFormat,
              selectedOption,
              decimalPlaces,
              separators: newSeparators,
              symbol: newSymbol,
            },
          },
        };
      }

      const response = await mySpaceTableColumnUpdate({ body: { ...fieldData }, params });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );

        await fetchMySpaceHeaderConfig(containerId);
        setExtraField((prev) => !prev);
        setIsEditableFieldModeActive(null);
        setIsModalOpen(false);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleDeleteTableColumnOption = async (fieldId, optionId) => {
    try {
      const response = await mySpaceDeleteOption({
        params: { fieldId: fieldId, optionId: optionId },
      });
      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );

        const fieldOptionsResponse = await mySpaceFieldOptions({ params: { fieldId: fieldId } });
        const formatedOptionsResponse = fieldOptionsResponse?.data?.map((data) => {
          return {
            value: data?.value,
            color_code: data?.color_code,
            uuid: data?.id,
            field_id: fieldId,
          };
        });
        setIsEditableFieldModeActive((prev) => ({
          ...prev,
          field_options: formatedOptionsResponse,
        }));
        // await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleAddColumnOptions = async (fielddata, createdNewColumnId) => {
    try {
      const body = {
        option: fielddata?.field_options?.map((item) => {
          return {
            value: item?.value,
            color: item?.color_code,
          };
        }),
      };

      const response = await mySpaceAddColumnOptions({ body, params: { tableColumnId: createdNewColumnId } });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleEditColumn = async (columnId) => {
    headerConfigData.map(async (item) => {
      if (item?.value === columnId?.columnDef?.accessorKey) {
        let optionsFormat = {
          field_name: item?.value,
          field_label: item?.label,
          field_options: [],
          field_type: item?.type,
          field_description: "",
          id: item?.id,
          selectedOption: item?.meta?.textFormat?.textSelectedOption || "Plain Text",
          // For number type column
          negativeFormat: item?.meta?.numberFormat?.negativeFormat || "MinusSign",
          decimalPlaces: item?.meta?.numberFormat?.decimalPlaces || 0,
          separators: item?.meta?.numberFormat?.separators || false,
          symbol: item?.meta?.numberFormat?.symbol || false,
          // For number type column
          numberFormat: item?.meta?.numberFormat || {},
        };

        if (item?.type === "dropdown" || item?.type === "multiselect") {
          const fieldOptionsResponse = await mySpaceFieldOptions({ params: { fieldId: item?.id } });
          const formatedOptionsResponse = fieldOptionsResponse?.data?.map((data) => {
            return {
              value: data?.value,
              color_code: data?.color_code,
              uuid: data?.id,
              field_id: item?.id,
            };
          });
          optionsFormat.field_options = formatedOptionsResponse;
        } else if (item?.type === "number") {
          Object.keys(item?.meta?.numberFormat)?.forEach((data) => {
            optionsFormat = { ...optionsFormat, [data]: item?.meta?.numberFormat[data] };
          });
        }
        setIsEditableFieldModeActive(optionsFormat);
      }
    });
    setExtraField(true);
  };

  const handleDeleteColumn = async (columnId) => {
    try {
      let column_id;
      headerConfigData.forEach(async (item) => {
        if (item?.value === columnId?.columnDef?.accessorKey) {
          column_id = item?.id;
        }
      });

      const response = await mySpaceDeleteColumns({
        params: { tableId: containerId },
        body: { fieldIds: [column_id] },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const cursorloader = customerListFetching || customerListFetching || customerListLoading;

  // FETCH MY SPACE TABLE HEADERS
  const fetchMySpaceHeaderConfig = async (containerId) => {
    try {
      setIsApiLoading(true);
      const response = await mySpaceGetHeaders({ params: { tableId: containerId } });
      if (response?.success) {
        setHeaderConfigData(() => response?.data);
        const breadcrumpList = response?.path?.map((data) => {
          // Only root folder will be considered as container. so is Null
          return {
            label: data?.folderName,
            id: data?.folderId,
            isContainer: data?.folderId ? true : false,
          };
        });
        setBreadcrumpList(breadcrumpList || [{ label: "My Space", id: null, isContainer: true }]);
        // Defining visibility of columns based on response and previous state.
        handleManageDrawerData(response?.data);
        await fetchMySpaceTableBodyData(containerId, response?.data);
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  const handleManageDrawerData = (headerData) => {
    setColumnVisibility((prev) => {
      const allHeaderColumnsValue = headerData?.map((object) => object.value) || [];

      // Filter out fields that are not present in header data
      const newVisibleFields = prev?.visible_fields?.filter((value) => allHeaderColumnsValue.includes(value)) || [];
      const newHiddenFields = prev?.hidden_fields?.filter((value) => allHeaderColumnsValue.includes(value)) || [];

      // Find fields in headerData that are not in either visible or hidden, and add them to visible
      const missingFields = allHeaderColumnsValue.filter(
        (value) => !newVisibleFields.includes(value) && !newHiddenFields.includes(value)
      );

      return {
        ...prev,
        visible_fields: [...newVisibleFields, ...missingFields],
        hidden_fields: newHiddenFields,
      };
    });
  };

  const fetchMySpaceTableBodyData = async (tableId, headerData) => {
    try {
      const response = await mySpaceData({ params: { tableId } });

      if (response?.success) {
        // Factory for a fresh empty-entry based on headers
        const makeEmpty = () => createEmptyEntry(headerData);

        // Pull out and flatten each row’s entire data object
        const existingEntries = response.data.map((item) => ({
          ...item.data,
          id: item.row_id,
        }));

        // Merge defaults (empty) with actual data, ensuring all keys exist
        const filledEntries = existingEntries.map((dataObj) => ({
          ...makeEmpty(),
          ...dataObj,
        }));

        if (headerData?.length > 0) {
          // Set state: all filled rows + one completely blank row at the end
          setMySpaceBodyData([...filledEntries, makeEmpty()]);
        }
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response.data?.message || "Something Went Wrong.",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleBreadcrumpDataClicked = (data) => {
    // handleGetContainerList({ containerId: data?.id });
    let newUrl;
    if (data?.id) {
      if (isShared) {
        newUrl = `/my_space/shared/folders/${data?.id}`;
      } else {
        newUrl = `/my_space/folders/${data?.id}`;
      }
    } else {
      if (isShared) {
        newUrl = `/my_space/shared/folders`;
      } else {
        newUrl = `/my_space/folders`;
      }
    }
    navigate(newUrl, { replace: false });
  };

  const createEmptyEntry = (headerData) => {
    // Mapping through header data to create empty entry
    try {
      const emptyEntry = {};
      headerData?.forEach((header) => {
        emptyEntry[header?.value] = null;
      });
      return emptyEntry;
    } catch (error) {
      console.log(error);
    }
  };

  const deleteBulkRowsInTable = async () => {
    try {
      const checkBoxSelectedIds = Object.keys(multiData).filter((info) => {
        return !isNaN(Number(info));
      });
      const response = await mySpaceTableRowDelete({
        params: { tableId: containerId },
        body: {
          rowIds: checkBoxSelectedIds ?? [],
        },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        setMultiData({});
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };
  const deleteSingleRowInTable = async (idsToBeDelete = null) => {
    try {
      const response = await mySpaceTableRowDelete({
        params: { tableId: containerId },
        body: {
          rowIds: idsToBeDelete ?? [],
        },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        setMultiData({});
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const isMySpaceCreateColumnHtml = () => {
    return (
      <div className="w-full h-full bg-gray-100 flex justify-center items-center">
        <div className="w-full h-full flex flex-col justify-center items-center">
          <CreateSomethingNew className="w-[400px] h-[300px]" />
          <Button
            onClick={() => {
              setExtraField(true);
            }}
            className="!w-[300px]"
          >
            + Create First Column
          </Button>
        </div>
      </div>
    );
  };

  const handleFieldVisibility = (data) => {
    setColumnVisibility((prev) => {
      if (prev.hidden_fields.includes(data)) {
        prev.hidden_fields?.splice(prev.hidden_fields?.indexOf(data), 1);
        return {
          visible_fields: [...prev.visible_fields, data],
          hidden_fields: [...prev.hidden_fields],
        };
      } else {
        if (prev.visible_fields?.includes(data)) {
          prev.visible_fields?.splice(prev.visible_fields?.indexOf(data), 1);
        }
        return {
          visible_fields: [...prev.visible_fields],
          hidden_fields: [...prev.hidden_fields, data],
        };
      }
    });

    setMySpaceVisibleFields(containerId, {
      visible_fields: columnVisibility.visible_fields,
      hidden_fields: columnVisibility.hidden_fields,
    });
  };

  useEffect(() => {
    // Subtracting to total count to remove empty entry at the last.
    setTotalCount(mySpaceBody?.length - 1);
  }, [mySpaceBody]);

  // When click on file, the headerAPI will be called and update the table content.
  useEffect(() => {
    if (containerId) {
      fetchMySpaceHeaderConfig(containerId);
    }
  }, [containerId]);

  useEffect(() => {
    if (cursorloader) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [cursorloader]);

  useEffect(() => {
    if (customerTableALL) {
      setMultiData({});
    }
  }, [customerTableALL]);

  useEffect(() => {
    if (location.key) {
      dispatch(getUserTokeData());
    }
  }, [location.key]);

  useEffect(() => {
    if (!menuVisible) {
      setIsMangeHovered(false);
    }
  }, [menuVisible]);

  useEffect(() => {
    setTableColumnsVisibility(() => {
      let fields = {};
      columnVisibility?.visible_fields?.forEach((field) => {
        fields[field] = true;
      });
      columnVisibility?.hidden_fields?.forEach((field) => {
        fields[field] = false;
      });
      return {
        ...fields,
      };
    });
  }, [columnVisibility]);

  useEffect(() => {
    if (containerId) {
      const columnOrderLocalState = getMySpaceColumnOrder(containerId);
      const visibleFieldsLocalState = getMySpaceVisibleFields(containerId);
      if (visibleFieldsLocalState) {
        setColumnVisibility(visibleFieldsLocalState);
      }
      setColumnOrder(columnOrderLocalState || []);
    }
  }, [containerId]);

  useEffect(() => {
    setContainerId(urlContainerId);
    setShowListView(type === "tables");
  }, [urlContainerId, type]);

  //function to generate unique values based on myspace response

  // generateUniqueValuesForPage.js

  return (
    <Fragment>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          // Optional: reset state, refetch, or navigate to safe path
          window.location.reload();
        }}
      >
        <div className="px-4 pt-0.5 h-full" id="innercontent">
          {showListView && (
            <div
              id="default-styled-tab-content"
              className="tablemaindiv h-full"
              // style={{ display: showListView ? "block" : "none" }}
            >
              <div className={`h-full `} id="styled-profile" role="tabpanel" aria-labelledby="profile-tab">
                <div className="h-full">
                  <CustomerReactTable
                    headers={columns || []}
                    body={memoizedCustomerData || []}
                    tableDetail={{
                      tableFilter: (
                        <div className="w-[100%] flex items-center px-3">
                          <Breadcrumb
                            breadcrumpList={breadcrumpList}
                            setBreadcrumpList={setBreadcrumpList}
                            handleClick={handleBreadcrumpDataClicked}
                            maxBreadcrumpsLength={10}
                          />
                          {/* <span
                            onClick={() => {
                              setShowListView(false);
                              navigate(-1);
                              setContainerId(null);
                              // setHeaderConfigData([]);
                              // setMySpaceBodyData([]);
                            }}
                            className="text-[#1D4469] font-bold cursor-pointer"
                          >
                            <ArrowBackIcon /> <span className="ms-2">{selectedRecord}</span>
                          </span> */}
                        </div>
                      ),
                    }}
                    isMySpace={true}
                    fetchPersonInTable={fetchPersonData}
                    rawHeaders={headerConfigData}
                    fetchtableBodyData={fetchFieldOptions}
                    customerCommnData={fieldOptionsData}
                    TableFieldUpdate={handleTableFieldUpdate}
                    noExcelDownload={false}
                    ExtraFields={
                      <div className="flex items-center h-full">
                        <div>
                          {isModalOpen && (
                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
                              <div className="bg-white p-5 rounded shadow-lg w-[530px]">
                                <div className="flex  justify-between border-b-2">
                                  <h2 className="text-16 font-500 mb-2 text-[#434852] ">Save as View</h2>
                                  <ClosePopUpIcn onClick={closeModal} />
                                </div>
                                <div className="pt-2">
                                  <h1 className="mb-1 text-[#434852] text-14 font-400">Name</h1>
                                  <input className="border-[#DFE2E5] w-[490px] pl-2 text-[#4F4F4F] text-12"></input>
                                </div>
                                <div className="sticky bottom-0 pt-4 flex justify-between  text-md w-full rounded-none z-[9998]">
                                  <div className="space-x-1 text-[#2999BC]">
                                    <input
                                      className="focus:outline-none focus:ring-0 border-[#2999BC] rounded-sm"
                                      type="checkbox"
                                      id="check1"
                                      name="check1"
                                      value="Bike"
                                    />
                                    <label for="check1"> Make It Public</label>
                                  </div>
                                  <div className="">
                                    <button
                                      onClick={closeModal}
                                      type="button"
                                      className="w-28 text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-normal px-5 py-1 text-center rounded-5px"
                                    >
                                      CANCEL
                                    </button>
                                    <button
                                      onClick={closeModal}
                                      type="submit"
                                      className="w-28 text-white bg-1D4469 hover:bg-20486F ok-btn font-normal border border-gray-200 py-1 px-5 ms-3 rounded-5px"
                                    >
                                      OK
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="flex items-center ml-1">
                          {Object.keys(multiData)?.length > 0 && (
                            <div>
                              <button
                                onClick={() => {
                                  setIsActive(!isActive);
                                  setShowConfirmDialog({
                                    show: true,
                                    data: {
                                      title: "Delete",
                                      message: "Are you sure want to delete Selected Items?",
                                      callback: deleteBulkRowsInTable,
                                      variant: "delete",
                                      confirmText: "Delete",
                                      cancelText: "Cancel",
                                    },
                                  });
                                }}
                                className={`flex items-center gap-2 py-1 px-2 rounded 
    ${isActive ? "bg-red-100 text-red-600" : "text-red-600 hover:bg-red-100"}
  `}
                              >
                                <DeleteIcon />
                                Delete
                              </button>
                            </div>
                          )}
                          {/* <ToolTipComponent text="Add New Item"> */}
                          {/* <button
                            onClick={() => handleAddRow()}
                            className="flex text-primary items-center gap-2 py-1 px-2 rounded border-[1px] border-primary mx-2"
                          >
                            <AddIcon color="var(--color-primary)" />
                            Add Record
                          </button> */}
                          {/* </ToolTipComponent> */}
                          {/* <ToolTipComponent text="Add Record">
                            <span
                              onClick={() => {
                               handleAddRow();
                              ;
                              }}
                              className="cursor-pointer"
                            >
                              <button className="border-[1px] border-[var(--color-primary)] rounded-full group hover:bg-[var(--color-primary)]">
                                <AddIcon className="text-primary group-hover:text-white" />
                              </button>
                            </span>
                          </ToolTipComponent> */}
                          {/* <ToolTipComponent text="Manage View" style={{ color: "#1D4469 " }}>
                            <span
                              onClick={() => setMenuVisible((prev) => !prev)}
                              className="cursor-pointer  border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
                            >
                              <ManageIcon isActive={menuVisible} isHovered={isMangeHovered} />
                            </span>
                          </ToolTipComponent> */}
                        </div>
                      </div>
                    }
                    MainFields={
                      <div className="flex items-center justify-center gap-x-2">
                        <ToolTipComponent text="Manage View" style={{ color: "#1D4469 " }}>
                          <span
                            onClick={() => setMenuVisible((prev) => !prev)}
                            className="cursor-pointer  border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
                          >
                            <ManageIcon isActive={menuVisible} />
                          </span>
                        </ToolTipComponent>
                        <ToolTipComponent text="Add Record">
                          <span
                            onClick={() => {
                              handleAddRow();
                            }}
                            className="flex items-center justify-center cursor-pointer"
                          >
                            <AddItemPlus isActive={showAddEditModal?.show > 0} />
                          </span>
                        </ToolTipComponent>
                      </div>
                    }
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    columnOrder={columnOrder}
                    setColumnOrder={setColumnOrder}
                    totalCount={totalCount}
                    multiData={multiData}
                    setMultiData={setMultiData}
                    grouping={grouping}
                    setGrouping={setGrouping}
                    resetPageIndex={resetPageIndex}
                    setResetPageIndex={setResetPageIndex}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    showColumnEdit={true}
                    showColumnDelete={true}
                    editColumnCallBack={handleEditColumn}
                    columnVisibility={tableColumnsVisibility}
                    setColumnVisibility={setTableColumnsVisibility}
                    deleteColumnCallBack={(columnId) => {
                      setShowConfirmDialog({
                        show: true,
                        data: {
                          title: "Delete",
                          message: "Are you sure want to delete this column?",
                          callback: () => handleDeleteColumn(columnId),
                          variant: "delete",
                          confirmText: "Delete",
                          cancelText: "Cancel",
                        },
                      });
                    }}
                    rowClickDisabled={true}
                    headerConfigData={headerConfigData}
                    isMySpaceCreateColumnHtml={isMySpaceCreateColumnHtml}
                    noMenuOpenList={["is_deletable", "select"]}
                    apiStates={{
                      header: {
                        isLoading: false,
                        isError: false,
                      },
                      body: {
                        isLoading: false,
                        isError: false,
                      },
                    }}
                    alternateDivs={{
                      emptyData: (
                        <>
                          <div className="w-full h-full">
                            <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                              {/* <NoCustomerData className="h-[300px] w-[300px]" /> */}
                              <span className="text-14 text-[#666666] text-sm font-400 font-inter">
                                No Customer Data is Available.
                              </span>
                            </div>
                          </div>
                        </>
                      ),
                    }}
                    generateUniqueValues={generateUniqueValuesMySpace}
                    useGenerateUniqueValues={true}
                    useBuildOptionsFromList
                    buildOptionsFromList={buildOptionsFromListMySpace}
                    isAdvancedFilterOpen={isAdvancedFilterOpen}
                    setIsAdvancedFilterOpen={setIsAdvancedFilterOpen}
                    closeAdvancedFilter={closeAdvancedFilter}
                    // leftPanel={true}
                  />
                </div>
              </div>
            </div>
          )}
          {showCsvUploadPreview && (
            <CsvUploadPreview
              csvFileData={csvFileData}
              setCsvFileData={setCsvFileData}
              setShowCsvUploadPreview={setShowCsvUploadPreview}
              currentDirectoryId={containerId}
              mySpaceDocumentList={mySpaceDocumentList}
              showListView={showListView}
            />
          )}
          <MySpaceDocument
            setShowListView={setShowListView}
            setContainerId={setContainerId}
            containerId={containerId}
            // queryContainerId={queryContainerId}
            setSelectedRecord={setSelectedRecord}
            setShowCsvUploadPreview={setShowCsvUploadPreview}
            csvFileData={csvFileData}
            setCsvFileData={setCsvFileData}
            mySpaceDocumentList={mySpaceDocumentList}
            setMySpaceDocumentList={setMySpaceDocumentList}
            showListView={showListView || showCsvUploadPreview}
            isShared={isShared}
            type={type}
          />
        </div>

        {extraField && (
          <AddFieldDrawer
            open={extraField}
            onClose={() => {
              setExtraField((prev) => !prev);
              setIsEditableFieldModeActive(null);
            }}
            ExtraFieldAddHeader={handleAddTableColumn}
            EditFieldData={isEditableFieldModeActive}
            handleDeleteOption={(info) => {
              handleDeleteTableColumnOption(info?.field_id, info?.uuid);
            }}
            handleUpdateTableColumn={handleUpdateTableColumn}
            isMySpace={true}
          />
        )}

        {showConfirmDialog?.show && (
          <ConfirmationDialog
            open={showConfirmDialog?.show}
            title={showConfirmDialog?.data?.title}
            message={showConfirmDialog?.data?.message}
            iconVariant={showConfirmDialog?.data?.variant}
            onClose={() => setShowConfirmDialog(() => ({ data: {}, show: false }))}
            onConfirm={() => {
              showConfirmDialog?.data?.callback();
              setShowConfirmDialog(() => ({ data: {}, show: false }));
            }}
            onCancel={() => setShowConfirmDialog(() => ({ data: {}, show: false }))}
            confirmVariant={showConfirmDialog?.data?.variant}
            confirmText={showConfirmDialog?.data?.confirmText}
            cancelText={showConfirmDialog?.data?.cancelText}
          />
        )}

        {showAddEditModal?.show > 0 && (
          <TableListRowAddEditComponent
            open={showAddEditModal?.show > 0}
            onClose={() => setShowAddEditModal({})}
            prefilledFormData={showAddEditModal?.data}
            onSubmit={handleRowAddEditSubmit}
            mode={rowAddEditMode}
          />
        )}

        {menuVisible && (
          <ManageViewDrawer
            thead={headerConfigData}
            listViewData={columnVisibility}
            handleFieldVisibility={handleFieldVisibility}
            setMenuVisible={setMenuVisible}
            menuVisible={menuVisible}
            fieldOptionsData={fieldOptionsData}
            fetchFieldOptions={fetchFieldOptions}
            handleUpdateTableColumn={handleUpdateTableColumn}
            handleReorderFields={handleReorderFields}
            isMySpace={true}
            handleEditColumn={(columnValue) => handleEditColumn({ columnDef: { accessorKey: columnValue } })}
            setExtraField={() => setExtraField((prev) => !prev)}
            removeFieldApi={(columnValue) => {
              setShowConfirmDialog({
                show: true,
                data: {
                  title: "Delete",
                  message: "Are you sure want to delete this column?",
                  callback: () => handleDeleteColumn({ id: columnValue }),
                  variant: "delete",
                  confirmText: "Delete",
                  cancelText: "Cancel",
                },
              });
            }}
          />
        )}
        {/* <ShareFileModal open={true} close={() => setShowShareFileModal((prev) => !prev)} sharedAssetId={containerId} /> */}
      </ErrorBoundary>
    </Fragment>
  );
};

export default LayoutHOC(MySpace);
